import React, { useEffect, useState } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';
/** Calculate overflow tyoe */ export function useSliderOverflow(contentRef) {
    const [overflow, setOverflow] = useState('');
    const updateOverflow = useThrottle(()=>{
        let newOverflow = '';
        if (!contentRef.current) {
            return newOverflow;
        }
        const contentRect = contentRef.current.getBoundingClientRect();
        const scrollLeft = contentRef.current.scrollLeft;
        const scrollWidth = contentRef.current.scrollWidth;
        const scrollRight = scrollWidth - scrollLeft - contentRect.width;
        if (scrollLeft && scrollRight) {
            newOverflow = 'both';
        } else if (scrollLeft) {
            newOverflow = 'left';
        } else if (scrollRight) {
            newOverflow = 'right';
        }
        setOverflow(newOverflow);
    }, [], SCROLL_THROTTLE_TIMEOUT, {
        leading: true
    });
    useEffect(()=>{
        var _contentNode;
        const contentNode = contentRef.current;
        updateOverflow();
        window.addEventListener('resize', updateOverflow);
        (_contentNode = contentNode) === null || _contentNode === void 0 ? void 0 : _contentNode.addEventListener('scroll', updateOverflow);
        return ()=>{
            var _contentNode;
            window.removeEventListener('resize', updateOverflow);
            (_contentNode = contentNode) === null || _contentNode === void 0 ? void 0 : _contentNode.removeEventListener('scroll', updateOverflow);
        };
    }, [
        updateOverflow,
        contentRef
    ]);
    return overflow;
}
